import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const unlockPoll = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.SOCIAL.UNLOCK_POLL, data);
};

export default unlockPoll;
